// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"24":"881f1964","147":"2f7cb26b","201":"881f1964","260":"881f1964","311":"9dd42c6c","346":"881f1964","474":"51708196"}[chunkId] + ".chunk.css";
};